module.exports = __webpack_public_path__ + "images/application/layout-prefs-1d5e2e6b.svg";